import FieldsInvoiceTable from './FieldsInvoiceTable'

export default FieldsInvoiceTable
